import { combineReducers } from 'redux';
import {
  TIMESHEET_LIST_RECEIVED,
  AVAILABLE_STUDENTS_RECEIVED,
  TUTOR_SUBJECTS_RECEIVED,
  STUDENT_REMAINING_HOURS_RECEIVED,
  API_ERROR_OCCURRED
} from '../actions/actions';
import { reducer as formReducer } from 'redux-form';

const timesheetList = (state = null, action) => {
  switch (action.type) {
    case TIMESHEET_LIST_RECEIVED:
      return action.data || [];
    default:
      return state;
  }
};

const availableStudents = (state = null, action) => {
  switch (action.type) {
    case AVAILABLE_STUDENTS_RECEIVED:
      return action.data || [];
    default:
      return state;
  }
};

const tutorSubjects = (state = null, action) => {
  switch (action.type) {
    case TUTOR_SUBJECTS_RECEIVED:
      return action.data || [];
    default:
      return state;
  }
};

const studentRemainingHours = (state = {}, action) => {
  switch (action.type) {
    case STUDENT_REMAINING_HOURS_RECEIVED:
      return { ...state, [action.studentId]: action.data };
    default:
      return state;
  }
};

const apiError = (state = null, action) => {
  switch (action.type) {
    case API_ERROR_OCCURRED:
      return { message: action.message, refresh: true };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  timesheetList,
  availableStudents,
  tutorSubjects,
  apiError,
  studentRemainingHours,
  form: formReducer
});

export default rootReducer;
